import { render, staticRenderFns } from "./Snippet_Medium.vue?vue&type=template&id=01a7fc32&"
import script from "./Snippet_Medium.vue?vue&type=script&lang=js&"
export * from "./Snippet_Medium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports